module.exports = __webpack_public_path__ + "static/media/bg-img.a24f336a.svg";